/*
* Copyright (c) 2026 Send2Me, media capture and delivery platform. All rights reserved.
* Distributed under the TruVideo proprietary license.
*/
import publicServiceRequestClient from '../api/publicServiceRequestClient';

export const publicServiceRequestService = {
  // GET /api/public/service-requests/:code
  getByCode: (code) => publicServiceRequestClient.get(`/${code}`),
};
